import React from "react";
import "../profile/Profile.css";
import hokou from "./image/hokou.gif";
function profile() {
  return (
    <div class="container">
      <h2 class="profile">research</h2>
      <section class="research_wrapper">
        <div class="research_container">
          <div class="content">
            <div class="content-item">
              <img class="hokou" src={hokou} alt="dance" />
            </div>
            <div class="content-text">
              <div class="text">
                <div class="ph">
                  <h2 class="heading">-learning to walk-</h2>
                </div>
                <p>UnityとUnityで強化学習を使えるようにする</p>
                <p>ML-Agentsを用いて人間の歩行習得には</p>
                <p>どのような要因や環境が必要になるのかを研究している</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default profile;
